import {Pipe, PipeTransform} from '@angular/core';
import {EventItem, EventStatus, League} from "@model";

@Pipe({
  name: 'leagueEventsToGo'
})
export class LeagueEventsToGoPipe implements PipeTransform {

  transform(value?: League): number {
    var eventsToGo:number = 0;
    if (value) {
      eventsToGo = this.calculateEventsToGo(value);
    }
    return eventsToGo;
  }

  private calculateEventsToGo(league?: League): number {
    var eventsToGo: number = 0;
    if (league && (league.events?.length ?? 0) > 0) {
      league!.events?.forEach((item: EventItem) => {
        if (item.status === EventStatus.ACTIVE) {
          eventsToGo++;
        }
      });
    }
    return eventsToGo;
  }
}
